"use client";

import { useLayoutEffect, useRef } from "react";

import {
  clampComposerInputHeight,
  COMPOSER_INPUT_MAX_HEIGHT,
  COMPOSER_INPUT_MIN_HEIGHT,
  COMPOSER_LINE_HEIGHT,
} from "./composerSizing";
import { cn } from "@/shared/lib/utils/cn";

interface ComposerInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
  disabled?: boolean;
}

export function ComposerInput({
  value,
  onChange,
  onSubmit,
  placeholder,
  disabled,
}: ComposerInputProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "0px";
    el.style.height = `${clampComposerInputHeight(el.scrollHeight)}px`;
  }, [value]);

  return (
    <textarea
      ref={ref}
      data-testid="composer-input"
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      rows={1}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter" && !e.shiftKey) {
          e.preventDefault();
          onSubmit?.();
        }
      }}
      className={cn(
        "composer-scroll block w-full resize-none border-0 bg-transparent px-4 pt-4 pb-3 text-[14px] outline-none",
        "placeholder:text-muted-foreground/50 focus-visible:outline-none",
        "disabled:cursor-not-allowed disabled:opacity-50",
      )}
      style={{
        boxSizing: "border-box",
        lineHeight: `${COMPOSER_LINE_HEIGHT}px`,
        minHeight: COMPOSER_INPUT_MIN_HEIGHT,
        maxHeight: COMPOSER_INPUT_MAX_HEIGHT,
        overflowY: "auto",
      }}
    />
  );
}
